/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TodoInputs */

const cs_enum_todo = /** @type {(inputs: Enum_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K udělání`)
};

const en_enum_todo = /** @type {(inputs: Enum_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To do`)
};

/**
* | output |
* | --- |
* | "To do" |
*
* @param {Enum_TodoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_todo = /** @type {((inputs?: Enum_TodoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TodoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_todo(inputs)
	return cs_enum_todo(inputs)
});